import script from "./PropertyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyDetail.vue?vue&type=script&setup=true&lang=js"

import "./PropertyDetail.vue?vue&type=style&index=0&id=72e1f184&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e1f184"]])

export default __exports__